import { Customer } from '../../../../../entities/@account/Customer/Customer';
import {
    FormErrors,
    FormValidation,
    validateEmailAddress,
    validateForm,
    validatePhoneNumber,
    validateRequiredString,
} from '../../../../../entities/@forms/FormValidation/FormValidationService';

export type MyDataFormErrors = FormErrors<Customer>;

export const validateMyDataFormData = (formData: Customer): FormValidation<MyDataFormErrors> => {
    const password = formData.password?.length
        ? validateRequiredString('password', formData.password)
        : undefined;

    const errors: MyDataFormErrors = {
        firstName: validateRequiredString('firstName', formData.firstName),
        lastName: validateRequiredString('lastName', formData.lastName),
        email: validateEmailAddress(formData.email),
        password,
        phoneNumber: validatePhoneNumber(formData.phoneNumber),
    };

    return validateForm<MyDataFormErrors>(errors);
};
